import React, { useState, useEffect } from 'react';
import { formatCurrency } from '../../utils/formatters';

const EditPriceModal = ({ isOpen, onClose, onSave, product }) => {
    const [newPrice, setNewPrice] = useState('');

    useEffect(() => {
        if (product && isOpen) {
            setNewPrice(Number(product.salePrice).toFixed(2));
        }
    }, [product, isOpen]);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await onSave(product.id, parseFloat(newPrice));
            onClose();
        } catch (error) {
            console.error("Erro ao atualizar preço: " + error.message);
            // Em uma aplicação real, mostraríamos uma notificação de erro para o usuário
        }
    };

    return (
        <div className="modal-overlay">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-sm m-4 sm:m-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">Editar Preço de Venda</h2>
                <p className="text-gray-600 mb-4 truncate">{product?.name}</p>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="form-label">Custo Atual (R$)</label>
                        <input value={formatCurrency(product?.cost || 0)} type="text" className="w-full px-4 py-2 border border-gray-200 bg-gray-100 rounded-lg" readOnly />
                    </div>
                    <div>
                        <label htmlFor="newSalePrice" className="form-label">Novo Preço de Venda (R$)</label>
                        <input 
                            id="newSalePrice" 
                            value={newPrice} 
                            onChange={(e) => setNewPrice(e.target.value)} 
                            type="number" 
                            step="0.01" 
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
                            required 
                            autoFocus
                        />
                    </div>
                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-4">
                        <button 
                            type="button" 
                            onClick={onClose} 
                            className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 w-full sm:w-auto"
                        >
                            Cancelar
                        </button>
                        <button 
                            type="submit" 
                            className="custom-button py-2 px-6 font-semibold rounded-lg w-full sm:w-auto"
                        >
                            Salvar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditPriceModal;
